import parse from "html-react-parser";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getFirstPetitionImage } from "../../../helpers/petitionImages";
import { getTags } from "../../../store/petition/petitionActions";
import "./Petition.scss";

const Petition = ({ petition }) => {
  const { tags } = useSelector((state) => state.petitions);
  const [petitionTag, setPetitionTag] = useState([]);
  const [maxDescriptionLength, setMaxDescriptionLength] = useState(100);
  const { t } = useTranslation("global");

  const dispatch = useDispatch();

  // Получаем первое изображение один раз
  const firstImage = getFirstPetitionImage(petition);

  useEffect(() => {
    dispatch(getTags());
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    const filteredTags = tags.filter((tag) => petition.tags.includes(tag.id));
    setPetitionTag(filteredTags);
  }, []);

  // Получаем количество голосов с fallback на 0
  const signaturesCount = petition.signatures_count || petition.support_votes || 0;
  const progressPercent = (signaturesCount / 10000) * 100;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMaxDescriptionLength(50);
      } else {
        setMaxDescriptionLength(100);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const truncatedDescription =
    petition?.description?.length > maxDescriptionLength
      ? `${petition.description.slice(0, maxDescriptionLength)}...`
      : petition.description;

  return (
    <div
      className="petition"
      onClick={() => navigate(`/petitions/${petition.id}`)}
    >
      <div className="petition__content">
        <div className="petition__left">
          <div className="petition__tags">
            {petitionTag?.map((tag) => (
              <p key={tag.id} className="petition__tag">
                {tag.name}
              </p>
            ))}
          </div>
          <div className="petition__header">
            <h5 className="petition__title">{petition.title}</h5>
          </div>
          <div>{parse(truncatedDescription)}</div>
          <div className="progress-bar-container">
            <div className="progress-bar">
              <div
                className="progress-bar-fill"
                style={{ width: `${progressPercent}%` }}
              ></div>
            </div>
            <p className="count">
              {t("petitions.amount")} {signaturesCount}{" "}
              {t("petitions.out")} 10 000
            </p>
          </div>
        </div>
        <div className="petition__right">
          {firstImage && (
            <img 
              className="petition__img" 
              src={firstImage} 
              alt="petition" 
            />
          )}
        </div>
      </div>
      <div className="progress-bar__second">
        <div className="progress-bar">
          <div
            className="progress-bar-fill"
            style={{ width: `${progressPercent}%` }}
          ></div>
        </div>
        <p className="count">
          {t("petitions.amount")} {signaturesCount} {t("petitions.out")}{" "}
          10 000
        </p>
      </div>
    </div>
  );
};

export default Petition;
